'use client';

import { useEffect } from 'react';
import { initMonitor } from '@/lib/monitor';

/**
 * 崩溃 + 性能监控挂载点（v1.0 正式发布包）：
 * 全站（Web + App）生效，window error / rejection / 首屏性能 / 慢接口上报。
 */
export default function Monitor() {
  useEffect(() => {
    initMonitor();
  }, []);
  return null;
}
